import { Box, Link, Typography } from '@mui/material';
import ArrowRightIcon from 'assets/img/icons/ArrowRightIcon';
import TooltipIcon from 'pages/PlaygroundV2Page/components/TooltipIcon';

const NoSourcesTooltip = () => {
  const toolTipContent = (
    <Box>
      <Typography
        color="#ffffff"
        sx={{
          fontSize: { desktop: '13px', tablet: '12px', mobile: '12px' },
          mt: 1,
        }}
      >
        We didn&apos;t find any reliable sources to support this claim.
      </Typography>
      <Typography
        color="#ffffff"
        sx={{
          fontSize: { desktop: '13px', tablet: '12px', mobile: '12px' },
        }}
      >
        Please treat this claim with caution until trustworthy sources become available.
      </Typography>
      <Link
        href="https://www.factiverse.ai/blog/how-factiverse-scans-the-web-to-tackle-misinformation-at-scale"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontSize: { desktop: '13px', tablet: '12px', mobile: '12px' },
          marginTop: '8px',
          marginBottom: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          color: '#FFFFFFB2',
          textDecorationColor: '#FFFFFFB2',
        }}
      >
        Learn more about fact- checking process
        <ArrowRightIcon rotation="-45" />
      </Link>
    </Box>
  );

  return <TooltipIcon tooltip={toolTipContent} />;
};

export default NoSourcesTooltip;
